import { makeStyles } from '@material-ui/core';

import checkedIcon from '../../images/check_icon.svg';
import NftImagePlaceholder from '../../images/nftImagePlaceholder.svg';

export const useInputAndDisplayNftsStyles = makeStyles((theme) => ({
  inputLabel: {
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '20px',
    color: '#FAFAFA',
  },
  nftInput: {
    position: 'relative',
  },
  nftInputLabel: {
    position: 'absolute',
    color: '#ABABAB',
    top: 20,
    right: 20,
    fontSize: 14,
    fontWeight: 500,
  },
  nftInputAddButton: {
    position: 'absolute',
    color: '#8D65F7',
    fontSize: 14,
    fontWeight: 500,
    top: 20,
    right: 17,
    padding: '0',
    cursor: 'pointer',
  },
  displaySelectedNftsWrapper: {
    display: 'grid',
    transition: 'all 0.3s ease',
  },

  displaySelectedNftsWrapperOpened: {
    padding: '0 7px',
    background: 'rgba(255, 255, 255, 0.03)',
    borderRadius: '8px',
  },

  inputedIdsList: {
    display: 'flex',
    width: '100%',
    gap: 8,
    flexWrap: 'wrap',
    height: 100,
    overflow: 'hidden',
    transition: 'all 0.3s ease',
  },

  inputedIdsListOpened: {
    overflowY: 'scroll',
    height: 200,
    justifyContent: 'center',
    padding: '16px 0px 0px 0px',

    '&::-webkit-scrollbar-track': {
      margin: '20px',
      borderRadius: '10px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#939395',
      borderRadius: '10px',
      width: 4,
      height: 42,
    },
  },

  showMoreIds: {
    background: 'transparent',
    color: '#7258F0',
    border: 'none',
    cursor: 'pointer',
    padding: '8px 0',
  },

  idCardWrapper: {
    borderRadius: '8px',
    border: '1px solid #34353B',
    background: '#292A2F',
    display: 'grid',
    alignContent: 'center',
    justifyItems: 'center',
    padding: '8px 12px',
    gap: 8,
    width: 113,
    height: 100,
    transition: 'all 0.01s ease',
  },

  idCardWrapperOpened: {
    width: 105,
    height: 100,
  },
  idNftWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '0 auto',
  },
  delete: {
    padding: '0 0 0 4px',
    cursor: 'pointer',
  },
  nftImage: {
    borderRadius: '50%',
    border: '1px solid rgba(255, 255, 255, 0.20)',
  },
  imagePlaceholder: {
    overflow: 'hidden',
    width: 56,
    height: 56,
    background: `url(${NftImagePlaceholder}) no-repeat center center, #41434B`,
    border: '1px solid #41434B',
    borderRadius: 8,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  inputWrapper: {
    position: 'relative',
    cursor: 'pointer',

    '& .MuiOutlinedInput-input': {
      paddingRight: 80,

      '&::placeholder': {
        color: '#fff',
        opacity: '1',
      },
    },
  },
  emptyLst: {
    cursor: 'default',

    '& .MuiOutlinedInput-input': {
      paddingRight: 80,

      '&::placeholder': {
        color: '#b0b3bf',
        opacity: '1',
      },
    },
  },
  dropdown: {
    position: 'absolute',
    right: 0,
    left: 0,
    color: '#ABABAB',
    fontSize: '18px',
    background: '#2F2F34',
    borderRadius: '6px',
    display: 'grid',
    cursor: 'pointer',
    width: '100%',
    transform: 'scaleY(0.01)',
    opacity: 0,
    transition: 'transform 0.25s ease, opacity 0.25s ease, box-shadow 0.25s ease 0.15s',
    transformOrigin: 'center top',
    overflow: 'hidden',
    zIndex: 9,
    padding: '8px 12px',
    maxHeight: '200px',
  },
  dropdownOpen: {
    margin: '3px auto',
    transform: 'scaleY(1)',
    opacity: 1,
    maxHeight: '200px',
    overflowY: 'scroll',
    zIndex: 999,
    background: '#34353B',
    height: 'min-content',
    borderRadius: 12,

    '&::-webkit-scrollbar': {
      width: '3px',
      // backgroundColor: '#ABABAB',
    },
    '&::-webkit-scrollbar-track': {
      borderRadius: '3px',
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: '3px',
      backgroundColor: '#376BDA2A',
    },
  },
  loader: {
    margin: 'auto',
  },
  nftItem: {
    display: 'flex',
    minHeight: 40,
    padding: '12px 0',
    alignItems: 'center',
    gap: 8,
    borderTop: '1px solid #48494F',
    '&:first-child': {
      borderTop: '0px solid #48494F',
    },
  },
  dropDownTitle: {
    color: '#FAFAFA',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
  },
  dropDownimg: {
    borderRadius: 8,
    border: '1px solid rgba(255, 255, 255, 0.20)',
    marginLeft: 8,
  },
  dropDownId: {
    marginLeft: 'auto',
    color: '#FAFAFA',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
  },
  checkBox: {
    height: 20,
    width: 20,
    border: '1px solid rgba(255, 255, 255, 0.20)',
    borderRadius: 3,
  },
  checkBoxChecked: {
    background: `url(${checkedIcon}) no-repeat center center, linear-gradient(90deg, #574AEA 0%, #986BF9 100%)`,
    backgroundSize: '70% 70%, 100% 100%',
    border: 'none',
  },
  showMore: {
    background: 'transparent',
    color: '#FAFAFA',
    border: 'none',
    cursor: 'pointer',
  },
  selectAllTitle: {
    marginLeft: 8,
  },
  labelWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  labelSelectedAmount: {
    color: '#ABABAB',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
  },
  inputArrow: {
    transition: 'all 0.5s ease',
  },
  inputArrowOpened: {
    transform: 'rotate(180deg)',
  },
}));
